import {User} from '@cypro/engine/schema'
import {rankItem} from '@tanstack/match-sorter-utils'
import {FilterFn} from '@tanstack/react-table'

export const fuzzyFilter = <TData>(): FilterFn<TData> => {
  return (row, columnId, value, addMeta) => {
    const itemRank = rankItem(String(row.getValue(columnId) ?? ''), value)
    addMeta?.({itemRank})
    return itemRank.passed
  }
}

export const usersFuzzyFilter: FilterFn<User> = (row, _columnId, value, addMeta) => {
  const itemRank = rankItem(row.original.name, value)
  addMeta({itemRank})
  return itemRank.passed
}
